import { wrapUnknownToError } from 'src/helpers/wrapUnknownToError';

export function scrollToElementById(id: string) {
  try {
    const scrollElement = document.querySelector(`input[id="${id}"], div[id="${id}"], span[id="${id}"]`);

    if (scrollElement) {
      scrollElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  } catch (unknownError) {
    const error = wrapUnknownToError(unknownError);

    console.warn('scrollToElementById error:', error.message);
  }
}
